import React, {useEffect, useState} from 'react';

import {ArticlePageLayout} from '../../../components/DataDisplay';
import {ErrorIcon} from '../../../components/Icons';
import PopupFullPage from '../../../components/Popup/PopupFullPage';
import appConfig from '../../../config/appConfig';
import standaloneLocalization from '../../../config/standaloneConfig/standaloneLocalization';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import useStandaloneConfig from '../../../hooks/useStandaloneConfig';
import analyticsService from '../../../services/analyticsService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import routerService from '../../../services/routerService';

const NotCompatibleOSPopup = () => {
    const standaloneConfig = useStandaloneConfig();
    const {externalLinks} = standaloneConfig || {};
    const localizedStrings = getLocalizedStrings();
    const isLocalizedStringsEmpty = Object.keys(localizedStrings).length === 0;
    const localizationSource = isLocalizedStringsEmpty ? standaloneLocalization : localizedStrings;
    const iqosHomeUrl =
        isLocalizedStringsEmpty && standaloneConfig ? externalLinks.iqosHomeUrl : appConfig.getIqosHomeUrlFormatted();
    const [isAnaliticServiceEventCalled, setIsAnaliticServiceEventCalled] = useState(false);

    useEffect(() => {
        if (!isAnaliticServiceEventCalled) {
            setIsAnaliticServiceEventCalled(true);
            analyticsService.pushNotCompatibleIosVersionEvent();
        }
    }, [isAnaliticServiceEventCalled]);

    if (isLocalizedStringsEmpty && !standaloneConfig) {
        return null;
    }

    return (
        <PopupFullPage contentLabel={localizationSource[localizationKeys.PAIRING_NOT_COMPATIBILITY_VERSION_TITLE]}>
            <ArticlePageLayout
                icon={
                    <ErrorIcon
                        className='mb-6 h-9 w-9'
                        alt={localizationSource[localizationKeys.NOT_COMPATIBLE_OS_POPUP_IMG_FAILED_ICON_ALT]}
                    />
                }
                titleText={localizationSource[localizationKeys.PAIRING_NOT_COMPATIBILITY_VERSION_TITLE]}
                descriptionText={localizationSource[localizationKeys.PAIRING_NOT_COMPATIBILITY_VERSION_MESSAGE]}
                descriptionClassName='mb-[84px]'
                buttonPrimary={{
                    text: localizationSource[localizationKeys.PAIRING_NOT_COMPATIBILITY_VERSION_BUTTON],
                    onClick: () => routerService.blankLinkOpen(iqosHomeUrl),
                    className: 'mt-0 sm:min-w-[312px]',
                }}
                containerClassName='pt-16'
            />
        </PopupFullPage>
    );
};

export default NotCompatibleOSPopup;
